import type { CSSProperties } from 'react';
import { MancheteAnimada } from './manchete-animada';
import { Botao } from './botao';
import { MockProduto } from './mock-produto';
import { URL_APP } from '../dados/navegacao';

/**
 * Copy do headline e do subtítulo adaptada de
 * `apps/site/landing-antiga.html` (seção `.heroi`) — a tese do produto é a
 * mesma, só a peça visual ao lado mudou de "documento marcado" para o mock
 * do produto real.
 */
export function Hero(): JSX.Element {
  return (
    <section id="inicio" className="scroll-mt-24 pt-32 pb-20 sm:pt-40 sm:pb-28">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 lg:grid-cols-[1.05fr_1fr] lg:items-center">
        {/*
          NENHUM `Reveal` no herói — e é regra, não esquecimento.

          O parágrafo abaixo da manchete é o elemento de LCP da página nas
          duas viewports. Dentro de um `Reveal` ele nascia `opacity: 0` e só
          aparecia depois de baixar o bundle + hidratar + IntersectionObserver
          + 700ms de transição: LCP de 3,9s medido em localhost SEM throttle —
          o pré-render inteiro invisível atrás de uma animação. O herói está
          acima da dobra: renderiza visível no HTML; `Reveal` é para o que
          entra rolando, abaixo da dobra. A manchete continua animando porque
          é CSS puro no carregamento (`palavra-entra`), sem esperar JS.
        */}
        <div className="flex flex-col gap-6">
          {/*
            Era a lista de cidades do piloto. Saiu porque o produto atende
            qualquer escritório do país, e nomear três cidades faz o resto do
            Brasil ler "não é para mim".

            No lugar, o que qualifica o público SEM estreitar geografia: quem
            monta contrato social é escritório de contabilidade, em qualquer
            lugar.
          */}
          <p className="text-auth-texto-terciario text-xs font-medium tracking-[0.14em] uppercase">
            Para escritórios de contabilidade
          </p>
          <MancheteAnimada>
            {'O contrato social que você entregou ontem tem '}
            {/* O gradiente + brilho ficam num span INTERNO: o externo anima a
                ENTRADA (`palavra-entra`) e cada elemento só tem uma lista de
                animation — no mesmo nó, um mataria o outro. */}
            <span
              key="destaque"
              className="palavra-entra"
              style={{ '--atraso-palavra': '440ms' } as CSSProperties}
            >
              <span className="from-auth-marca-hover via-auth-acento to-auth-marca-hover texto-brilha bg-gradient-to-r bg-clip-text font-semibold text-transparent">
                erro
              </span>
            </span>
            .
          </MancheteAnimada>
          <p className="text-auth-texto-secundario max-w-lg text-lg leading-relaxed">
            Não é descuido seu. É o Word. Enquanto o documento for a fonte da verdade, o
            erro é questão de tempo — e a exigência da Junta chega semanas depois, quando
            o cliente já cobrou duas vezes.
          </p>
          <div className="flex flex-wrap items-center gap-4 pt-2">
            {/*
              Leva para o AUTOCADASTRO, que agora existe.

              Durante um bom tempo apontou para a captura de e-mail, porque
              criar conta ainda não era possível e mandar quem clica em
              "testar" para uma tela de login é o pior dos dois mundos — a
              pessoa esperava criar conta e encontrava pedido de senha. O
              formulário de contato continua logo abaixo, para quem prefere
              falar com gente antes.
            */}
            <Botao href={`${URL_APP}/criar-conta`} variante="primario">
              Criar meu escritório
            </Botao>
            <Botao href="#como-funciona" variante="fantasma">
              Ver como funciona
            </Botao>
          </div>
          <p className="text-auth-texto-terciario max-w-md text-sm">
            Grátis por 7 dias, sem cartão de crédito. Cadastra a sociedade, confere contra
            as regras e o contrato sai pronto para protocolo.
          </p>
        </div>

        {/*
          Sem entrada — só a flutuação perpétua (`flutua`, CSS puro). A
          entrada pela direita morava num `Reveal`, e saiu pela mesma razão
          do texto: o herói tem de estar na tela no primeiro paint do HTML
          pré-renderizado, não depois do bundle.

          A `luz-palco` mora FORA do `flutua`: a luz é o palco, o cartão é o
          ator — se ela flutuasse junto, deixaria de ler como iluminação e
          viraria parte do objeto.
        */}
        <div className="relative">
          <div aria-hidden className="luz-palco" />
          <div className="flutua">
            <MockProduto />
          </div>
        </div>
      </div>
    </section>
  );
}
